import React from 'react';
import { Button } from './ui/button';
import { Phone, Mail, MapPin } from 'lucide-react';
import { personalInfo } from '../mock';

const Hero = () => {
  const scrollToContact = () => {
    const element = document.getElementById('contact');
    if (element) {
      const offset = 80;
      const elementPosition = element.getBoundingClientRect().top;
      const offsetPosition = elementPosition + window.pageYOffset - offset;
      window.scrollTo({ top: offsetPosition, behavior: 'smooth' });
    }
  };

  return (
    <section id="home" className="pt-32 pb-20 px-4" style={{ backgroundColor: '#f8f9fa' }}>
      <div className="container mx-auto">
        <div className="grid md:grid-cols-2 gap-12 items-center">
          <div className="space-y-6">
            <div className="space-y-2">
              <h1 className="text-5xl md:text-6xl font-bold" style={{ color: '#1e3a5f' }}>
                {personalInfo.name}
              </h1>
              <p className="text-2xl font-semibold" style={{ color: '#c17835' }}>
                {personalInfo.title}
              </p>
              <p className="text-lg text-gray-600">
                {personalInfo.subtitle}
              </p>
            </div>

            <p className="text-gray-700 leading-relaxed text-lg">
              {personalInfo.description}
            </p>

            <div className="flex flex-wrap gap-4 pt-4">
              <Button
                onClick={scrollToContact}
                className="px-8 py-6 text-lg font-semibold"
                style={{
                  backgroundColor: '#1e3a5f',
                  color: 'white'
                }}
              >
                Entre em Contato
              </Button>
              <Button
                variant="outline"
                onClick={() => window.open(`https://wa.me/${personalInfo.whatsapp}`, '_blank')}
                className="px-8 py-6 text-lg font-semibold border-2"
                style={{
                  borderColor: '#1e3a5f',
                  color: '#1e3a5f'
                }}
              >
                WhatsApp
              </Button>
            </div>

            <div className="grid grid-cols-2 gap-6 pt-8">
              <div className="text-center p-4 bg-white rounded-lg shadow-sm">
                <p className="text-4xl font-bold" style={{ color: '#c17835' }}>
                  {personalInfo.yearsExperience}
                </p>
                <p className="text-gray-600 mt-1">Anos de Experiência</p>
              </div>
              <div className="text-center p-4 bg-white rounded-lg shadow-sm">
                <p className="text-4xl font-bold" style={{ color: '#c17835' }}>
                  {personalInfo.projectsCompleted}
                </p>
                <p className="text-gray-600 mt-1">Projetos Concluídos</p>
              </div>
            </div>
          </div>

          <div className="relative">
            <div className="aspect-square bg-white rounded-2xl shadow-xl overflow-hidden">
              <img
                src="https://images.unsplash.com/photo-1560518883-ce09059eeffa?w=800&q=80"
                alt="Propriedade Imobiliária"
                className="w-full h-full object-cover"
              />
            </div>
            <div className="absolute -bottom-6 -left-6 bg-white p-6 rounded-lg shadow-lg">
              <div className="flex items-center space-x-3">
                <div className="w-12 h-12 rounded-full flex items-center justify-center" style={{ backgroundColor: '#1e3a5f' }}>
                  <MapPin className="w-6 h-6 text-white" />
                </div>
                <div>
                  <p className="font-semibold" style={{ color: '#1e3a5f' }}>{personalInfo.location}</p>
                  <p className="text-sm text-gray-600">Atendimento Local</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Hero;